import { useRef } from 'react';
import clsx from 'clsx';

import { Paper } from '@highlight-cp/core-ui';
import { useIsSticky } from '@highlight-cp/hooks';

import classes from './control-bar.module.css';

interface ControlBarProps {
  children: React.ReactNode;
}

/**
 * A sticky control bar (used in project setup steps).
 *
 * @param children - The children to render inside the control bar.
 * @returns React component.
 */
const ControlBar = ({ children }: ControlBarProps) => {
  const controlBarRef = useRef<HTMLDivElement>(null);
  const { isSticky } = useIsSticky(controlBarRef);

  return (
    <Paper
      ref={controlBarRef}
      className={clsx(classes.root, isSticky && classes.sticky)}
      shadow="xs"
      radius="md"
      mb="sm"
      mt="md"
      py="xs"
      px="sm"
    >
      {children}
    </Paper>
  );
};

export default ControlBar;
